/**
 * Shared class fragments for the floating-variant nav dark-mode theming.
 * Each maps a semantic role to a CSS-var-driven colour with a light fallback,
 * so the bar, dropdown panels and mobile drawer invert on dark pages while
 * consumers without the dark rules (e.g. intercom-com) keep the fallback look.
 */
export const navFg = "text-[var(--nav-fg,var(--color-off-black))]";
// Subhead under a larger (primary) nav item: full foreground on light themes,
// muted on dark (globals.css sets --nav-subhead-fg per theme).
export const navSubheadFg =
  "text-[var(--nav-subhead-fg,var(--color-off-black))]";
export const navFgMuted =
  "text-[color-mix(in_oklab,var(--nav-fg,var(--color-off-black))_60%,transparent)]";
export const navFgMutedMobile =
  "text-[color-mix(in_oklab,var(--nav-fg,var(--color-off-black))_50%,transparent)]";
export const navDivider =
  "bg-[color-mix(in_oklab,var(--nav-fg,var(--color-off-black))_15%,transparent)]";
export const navPanelBg = "bg-[var(--nav-panel-bg,#fff)]";
export const navPanelBorder =
  "border-[var(--nav-panel-border,var(--color-clay))]";
export const navHoverBg = "hover:bg-[var(--nav-hover,var(--color-chalk))]";

// Underline colour defaults to 40% of the theme foreground, but an app can
// override `--nav-underline` for a paler line (intercom sets it to clay).
export const floatingUnderlineBase =
  "w-fit bg-gradient-to-r from-[var(--nav-underline,color-mix(in_oklab,var(--nav-fg,var(--color-off-black))_40%,transparent))] to-[var(--nav-underline,color-mix(in_oklab,var(--nav-fg,var(--color-off-black))_40%,transparent))] bg-[length:100%_1px] bg-[position:0%_100%] bg-no-repeat pb-px transition-[background-size] duration-200 ease-out";
export const floatingUnderlineGroupHover =
  "group-hover/link:bg-[length:0%_1px] group-hover/link:bg-[position:100%_100%]";
export const floatingUnderlineSelfHover =
  "hover:bg-[length:0%_1px] hover:bg-[position:100%_100%]";
